import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useMissingCustomerDetailsForm } from '../../../../../../contexts/missingCustomerDetailsFormContext'
import { CustomerAddressInputFieldProps } from '../../types/customerAddressInputFieldProps'

type CustomerStreetAddress2Props = CustomerAddressInputFieldProps

export const CustomerStreetAddress2 = ({ isDisabled = false }: CustomerStreetAddress2Props): ReactElement => {
  const { t } = useTranslation()
  const {
    missingCustomerDetailsForm: { FormItem },
  } = useMissingCustomerDetailsForm()

  return (
    <FormItem
      label={t('external_invoices.missing_customer_compliance_details.modal.form.field.address.street_address_2.label')}
      name="address.streetAddress2"
      render={({ field }) => {
        return <Input {...field} disabled={isDisabled} size="sm" />
      }}
    />
  )
}
